import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Los ebooks son digitales?',
  answer: 'Sí, todos nuestros ebooks son 100% digitales en formato PDF. Podés descargarlos y leerlos desde cualquier dispositivo.'
}, {
  question: '¿Cómo recibo mi compra?',
  answer: 'Una vez realizado el pago, recibirás el ebook directamente en tu correo electrónico en pocos minutos.'
}, {
  question: '¿Puedo leerlos desde el celular?',
  answer: '¡Sí! Están diseñados para leerse cómodamente desde el celular, tablet o computadora.'
}, {
  question: '¿Estos materiales reemplazan atención médica o psicológica?',
  answer: 'No. Nuestros ebooks son recursos informativos y de acompañamiento. No reemplazan la consulta con profesionales de la salud.'
}, {
  question: '¿A quiénes están dirigidos?',
  answer: 'A todas las mujeres que quieran conocer mejor su cuerpo, sus procesos y sus experiencias. No necesitás conocimientos previos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 md:py-32 bg-blanco" data-id="element-61">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-62">
        <FadeIn className="text-center mb-16" data-id="element-63">
          <h2 className="font-serif text-4xl md:text-5xl text-texto mb-6" data-id="element-64">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-65">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-66">
              <div className="border border-beige rounded-2xl overflow-hidden bg-crema/50" data-id="element-67">
                <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-68">
                  <span className="font-sans font-medium text-texto pr-4" data-id="element-69">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-textoSuave transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-70" />
                </button>
                <AnimatePresence data-id="element-71">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-72">
                      <div className="px-6 pb-5 font-sans text-textoSuave leading-relaxed" data-id="element-73">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} className="mt-12 text-center" data-id="element-74">
          <p className="font-sans text-sm text-textoSuave italic" data-id="element-75">
            * Recordá que el contenido es informativo y de acompañamiento, y que
            no reemplaza atención médica, psicológica ni profesional.
          </p>
        </FadeIn>
      </div>
    </section>;
}